module.exports = __webpack_public_path__ + "media/customizations/default/spinner-primary-490c24895d3970efba4d27dcbe0514bc.gif";